import type { ErrorSeverity } from './errorClassifier';
import { getErrorSignature } from './errorSignature';

type SessionErrorStore = {
  seen: Set<string>;
  fatalCount: number;
  lastSeen: number;
};

const SESSION_TTL = 30 * 60 * 1000;
const MAX_FATAL_ERRORS_PER_SESSION = 3;

const sessionErrors: Record<string, SessionErrorStore> = {};

const cleanupOldSessions = () => {
  const now = Date.now();

  Object.keys(sessionErrors).forEach((sessionId) => {
    if (now - sessionErrors[sessionId].lastSeen > SESSION_TTL) {
      delete sessionErrors[sessionId];
    }
  });
};

export const shouldSendError = (error: unknown, sessionId: string, severity: ErrorSeverity): boolean => {
  cleanupOldSessions();

  const signature = getErrorSignature(error);

  if (!sessionErrors[sessionId]) {
    sessionErrors[sessionId] = {
      seen: new Set(),
      fatalCount: 0,
      lastSeen: Date.now(),
    };
  }

  const store = sessionErrors[sessionId];
  store.lastSeen = Date.now();

  if (store.seen.has(signature)) {
    return false;
  }

  store.seen.add(signature);

  if (severity === 'fatal') {
    store.fatalCount += 1;

    if (store.fatalCount > MAX_FATAL_ERRORS_PER_SESSION) {
      return false;
    }
  }

  return true;
};
